"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContracts = void 0;
const tslib_1 = require("tslib");
const contracts_1 = require("@ethersproject/contracts");
const contractAddress_1 = require("./contractAddress");
const Ambassadors_json_1 = tslib_1.__importDefault(require("./abi/Ambassadors.json"));
const BaseERC20_json_1 = tslib_1.__importDefault(require("./abi/BaseERC20.json"));
const CommunityAdminABI_json_1 = tslib_1.__importDefault(require("./abi/CommunityAdminABI.json"));
const DepositRedirectABI_json_1 = tslib_1.__importDefault(require("./abi/DepositRedirectABI.json"));
const DonationMiner_json_1 = tslib_1.__importDefault(require("./abi/DonationMiner.json"));
const ImpactMarketCouncil_json_1 = tslib_1.__importDefault(require("./abi/ImpactMarketCouncil.json"));
const LearnAndEarnABI_json_1 = tslib_1.__importDefault(require("./abi/LearnAndEarnABI.json"));
const MerkleDistributor_json_1 = tslib_1.__importDefault(require("./abi/MerkleDistributor.json"));
const MicroCreditABI_json_1 = tslib_1.__importDefault(require("./abi/MicroCreditABI.json"));
const PACTDelegate_json_1 = tslib_1.__importDefault(require("./abi/PACTDelegate.json"));
const PACTToken_json_1 = tslib_1.__importDefault(require("./abi/PACTToken.json"));
const Staking_json_1 = tslib_1.__importDefault(require("./abi/Staking.json"));
const TreasuryABI_json_1 = tslib_1.__importDefault(require("./abi/TreasuryABI.json"));
const getContracts = (provider, networkId) => {
    const contractAddresses = contractAddress_1.ContractAddresses.get(networkId);
    const { Ambassadors, CommunityAdmin, LearnAndEarn, DepositRedirect, cUSD, cEUR, CELO, PACTDelegate, PACTDelegator, PACTToken, SPACTToken, DonationMiner, MicroCredit, MerkleDistributor, Staking, ImpactMarketCouncil, Treasury } = contractAddresses;
    const addresses = {
        ambassadors: Ambassadors || '',
        celo: CELO || '',
        ceur: cEUR || '',
        communityAdmin: CommunityAdmin || '',
        cusd: cUSD || '',
        delegate: PACTDelegate || '',
        delegator: PACTDelegator || '',
        depositRedirect: DepositRedirect || '',
        donationMiner: DonationMiner || '',
        impactMarketCouncil: ImpactMarketCouncil || '',
        learnAndEarn: LearnAndEarn || '',
        merkleDistributor: MerkleDistributor || '',
        microCredit: MicroCredit || '',
        pactToken: PACTToken || '',
        spactToken: SPACTToken || '',
        staking: Staking || '',
        treasury: Treasury || ''
    };
    const ambassadors = new contracts_1.Contract(addresses.ambassadors, Ambassadors_json_1.default, provider);
    const merkleDistributor = new contracts_1.Contract(addresses.merkleDistributor, MerkleDistributor_json_1.default, provider);
    const microCredit = new contracts_1.Contract(addresses.microCredit, MicroCreditABI_json_1.default, provider);
    const donationMiner = new contracts_1.Contract(addresses.donationMiner, DonationMiner_json_1.default, provider);
    const cusd = new contracts_1.Contract(addresses.cusd, BaseERC20_json_1.default, provider);
    const ceur = new contracts_1.Contract(addresses.ceur, BaseERC20_json_1.default, provider);
    const celo = new contracts_1.Contract(addresses.celo, BaseERC20_json_1.default, provider);
    const pact = new contracts_1.Contract(addresses.pactToken, PACTToken_json_1.default, provider);
    const spact = new contracts_1.Contract(addresses.spactToken, BaseERC20_json_1.default, provider);
    const staking = new contracts_1.Contract(addresses.staking, Staking_json_1.default, provider);
    const delegate = new contracts_1.Contract(addresses.delegate, PACTDelegate_json_1.default, provider).attach(addresses.delegator);
    const impactMarketCouncil = new contracts_1.Contract(addresses.impactMarketCouncil, ImpactMarketCouncil_json_1.default, provider);
    const learnAndEarn = new contracts_1.Contract(addresses.learnAndEarn, LearnAndEarnABI_json_1.default, provider);
    const depositRedirect = new contracts_1.Contract(addresses.depositRedirect, DepositRedirectABI_json_1.default, provider);
    const treasury = new contracts_1.Contract(addresses.treasury, TreasuryABI_json_1.default, provider);
    const communityAdmin = new contracts_1.Contract(addresses.communityAdmin, CommunityAdminABI_json_1.default, provider);
    return {
        addresses,
        ambassadors,
        celo,
        ceur,
        communityAdmin,
        cusd,
        delegate,
        depositRedirect,
        donationMiner,
        impactMarketCouncil,
        learnAndEarn,
        merkleDistributor,
        microCredit,
        pact,
        spact,
        staking,
        treasury
    };
};
exports.getContracts = getContracts;
//# sourceMappingURL=contracts.js.map